import { fetcherWithToken } from '@/shared/api/fetcher';
import { useEffect } from 'react';
import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import {
  useIsAuth,
  useIsUserLoading,
} from '@/shared/providers/user-provider/use-user';

const EMPTY_BONUSES: [] = [];

async function activateBonus(
  url: string,
  { arg }: { arg: { id: number; userBonusId?: string } }
) {
  const params = new URLSearchParams({ id: String(arg.id) });
  if (arg.userBonusId) {
    params.append('userBonusId', arg.userBonusId);
  }
  return fetcherWithToken(`${url}?${params.toString()}`, {
    method: 'GET',
  });
}

export const useBonuses = () => {
  const isAuth = useIsAuth();
  const isUserLoading = useIsUserLoading();
  const {
    data,
    isLoading: isBonusesLoading,
    mutate: mutateBonuses,
  } = useSWR(isAuth ? '/profile/getBonuses' : null, fetcherWithToken, {
    dedupingInterval: 5000, // Не повторять запросы чаще 5 сек
    errorRetryCount: 1, // Максимум 1 повтор при ошибке
    shouldRetryOnError: false, // Отключить повтор при 500 ошибках
  });
  const isLoading = isUserLoading || isBonusesLoading;
  const isInvalidBonusesResponse = data != null && !Array.isArray(data);
  const bonuses = isInvalidBonusesResponse
    ? EMPTY_BONUSES
    : (data ?? EMPTY_BONUSES);

  useEffect(() => {
    if (!isInvalidBonusesResponse) return;

    const errorMessage =
      typeof data === 'object' && 'error' in data
        ? String(data.error)
        : undefined;
    console.warn('Invalid bonuses response', errorMessage);
  }, [isInvalidBonusesResponse, data]);
  const { trigger: activate } = useSWRMutation(
    '/profile/activateBonus',
    activateBonus
  );
  const { trigger: deactivate } = useSWRMutation(
    '/profile/deactivateBonus',
    activateBonus
  );
  return {
    data: bonuses,
    mutateBonuses,
    activate,
    deactivate,
    isLoading,
  };
};
